import React from 'react';
/* eslint-disable max-len */

const ZoomOut = (): JSX.Element => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path fillRule="evenodd" clipRule="evenodd" d="M7 1C10.3141 1 13 3.68586 13 7C13 8.296 12.589 9.49576 11.8906 10.4766L17 15.5859L15.5859 17L10.4766 11.8906C9.49576 12.589 8.296 13 7 13C3.68586 13 1 10.3141 1 7C1 3.68586 3.68586 1 7 1ZM7 2C4.23814 2 2 4.23814 2 7C2 9.76186 4.23814 12 7 12C9.76186 12 12 9.76186 12 7C12 4.23814 9.76186 2 7 2Z" fill="black"/>
    </g>
  </svg>
);

export default ZoomOut;
